import { Mail, Rocket, Smartphone, StickyNote } from "lucide-react"

import type { ActionDefinition } from "../../types"

export const businessActions: ActionDefinition[] = [
  {
    key: "action__business_add_note",
    name: "Add note",
    description: "Add a note to the business record",
    category: "business",
    nodeType: "action",
    recordType: "business",
    icon: StickyNote,
    requiresSubjects: ["business"],
    fields: [
      { key: "content", label: "Note content", inputType: "markdown", required: true, supportsInterpolation: true },
      { key: "tag_id", label: "Label", inputType: "select", required: false, optionsSource: "note_tags" },
    ],
  },
  {
    key: "action__business_send_email",
    name: "Send email",
    description: "Send an email to the business's primary email address",
    category: "business",
    nodeType: "action",
    recordType: "business",
    icon: Mail,
    requiresSubjects: ["business"],
    singlePerBranch: true,
    fields: [
      {
        key: "email_integration_id",
        label: "Send from",
        inputType: "email_integration",
        required: true,
        optionsSource: "accessible_email_integrations",
      },
      {
        key: "email_content",
        label: "Email content",
        inputType: "email_content",
        required: true,
        defaultValue: { email_template_id: null, email_template_name: null, subject: "", body: { html: "" } },
        optionsSource: "email_templates",
        chatValueShape:
          'Either {"email_template_id":"<id>","email_template_name":"<name>","subject":"","body":{"html":""}} or {"email_template_id":null,"subject":"...","body":{"html":"..."}}',
        supportsInterpolation: true,
        interpolationHelperText: "Subject and body support variables from subject data and prior step results.",
      },
    ],
    chatFields: [
      {
        key: "cc_user_or_team_ids",
        label: "Additional internal recipients",
        inputType: "json",
        required: false,
        optionsSource: "assignments",
        chatValueShape:
          '{"user_ids":["<id after user: prefix>"],"team_ids":["<id after team: prefix>"],"type":"cc|bcc|none"}',
      },
    ],
  },
  {
    key: "action__business_send_sms",
    name: "Send SMS",
    description: "Send a text message to the business's primary phone number",
    category: "business",
    nodeType: "action",
    recordType: "business",
    icon: Smartphone,
    requiresSubjects: ["business"],
    singlePerBranch: true,
    fields: [
      {
        key: "sms_integration",
        label: "Send from",
        inputType: "sms_integration",
        required: true,
        optionsSource: "phone_integrations",
      },
      {
        key: "message",
        label: "Message",
        inputType: "sms_message",
        required: true,
        rows: 8,
        supportsInterpolation: true,
      },
    ],
  },
  {
    key: "action__business_start_project",
    name: "Start business project",
    description: "Start a project for the business from a business template",
    category: "business",
    nodeType: "action",
    recordType: "business",
    icon: Rocket,
    requiresSubjects: ["business"],
    providesSubjects: ["project"],
    fields: [
      {
        key: "project_template_id",
        label: "Project template",
        inputType: "select",
        required: true,
        optionsSource: "business_project_templates",
      },
      {
        key: "name",
        label: "Project name",
        inputType: "string",
        required: false,
        supportsInterpolation: true,
      },
      {
        key: "assignee",
        label: "Assigned to",
        inputType: "assignment_picker",
        required: false,
        optionsSource: "assignments",
        assignmentTypes: ["user"],
      },
    ],
  },
]
